<div class="row">
    <div class="mt-3 col-md-12">
        <div class="row">
            <div class="col-md-12">
                <b class="f-s-75-3"> Select Metrics </b>
                <h6
                    *ngIf="value?.length <= 1"
                    class="b-d-underline"
                >
                    You can only select {{ config.max }} metrics at a time
                </h6>
            </div>
        </div>
        <ul class="selection-list">
            <li
                *ngFor="let opt of value; let i = index; let last = last"
                (click)="onClickRemoveItem(opt.id)"
                class="clickable"
            >
                <cmps-icon
                    class="legacy:cmps-cdk-fill-green-100"
                    svgIcon="check-bold"
                ></cmps-icon>
                {{ opt.name }}
                <span
                    *ngIf="config.editable && opt.data"
                    (click)="$event.stopPropagation()"
                >
                    <span class="soft-pipe">|</span> Target:
                    <input
                        #el
                        class="selection-option-edit"
                        [hidden]="!opt.data.isEditing"
                        [(ngModel)]="opt.data.value"
                        (blur)="opt.data.isEditing = false"
                        (keypress)="onKeyPress($event)"
                        type="text"
                    />
                    <span
                        *ngIf="!opt.data.isEditing"
                        class="red"
                    >
                        {{ opt.data?.value }}
                    </span>
                    <button
                        (click)="onClickEdit(opt, el)"
                        class="green btn-mini"
                    >
                        <cmps-icon svgIcon="pencil"></cmps-icon>
                    </button>
                </span>
                <div
                    class="cmps-d-flex cmps-cdk-ml-auto cursor-default"
                    (click)="$event.stopPropagation()"
                    *ngIf="value?.length > 1"
                >
                    <button
                        class="cmps-icon-button--no-bg"
                        [class.invisible]="i === 0"
                        cmpsIconButton
                        (click)="_onMoveUpClick(opt)"
                    >
                        <cmps-icon svgIcon="arrow-up-thick"></cmps-icon>
                    </button>
                    <button
                        class="cmps-icon-button--no-bg"
                        cmpsIconButton
                        [class.invisible]="last"
                        (click)="_onMoveDownClick(opt)"
                    >
                        <cmps-icon svgIcon="arrow-down-thick"></cmps-icon>
                    </button>
                </div>
            </li>
        </ul>
        <div class="row">
            <div class="col-md-12">
                <div
                    class="input-group cmps-d-flex cmps-cdk-align-items-center"
                >
                    <input
                        [formControl]="search"
                        type="text"
                        class="form-control"
                        [placeholder]="
                            config.placeholder ? config.placeholder : '&nbsp;'
                        "
                    />
                    <span class="float-search">
                        <cmps-icon svgIcon="magnify"></cmps-icon>
                    </span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <h6
                    *ngIf="value?.length === config.max"
                    class="alert alert-warning text-center"
                >
                    You already selected {{ config.max }} metrics, please
                    deselect any one of your selected metrics first.
                </h6>
            </div>
        </div>
        <ul class="selection-list b-d-underline">
            <li
                (click)="onClickAddItem(opt.id)"
                *ngFor="let opt of filtered"
                class="clickable"
            >
                <cmps-icon
                    class="cmps-cdk-fill-grey-300"
                    svgIcon="check-bold"
                ></cmps-icon>
                {{ opt.name }}
            </li>
        </ul>
    </div>
</div>
